var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2em",
    height: "2em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsScale0",
    attributeName: "r",
    begin: "0;svgSpinners3DotsScale1.end-0.25s",
    dur: "0.75s",
    values: "3;.2;3"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "svgSpinners3DotsScale0.end-0.6s",
    dur: "0.75s",
    values: "3;.2;3"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsScale1",
    attributeName: "r",
    begin: "svgSpinners3DotsScale0.end-0.45s",
    dur: "0.75s",
    values: "3;.2;3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsAnimated);
export default __webpack_public_path__ + "static/media/dots_animated.c0428b283d4686c3468374eb37798915.svg";
export { ForwardRef as ReactComponent };